module.exports = __webpack_public_path__ + "img/corriente_c_blue.1a39a2bf.svg";